import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Overlay from "containers/general/overlay"
import { Redirect } from "react-router-dom"
import LoadingOverlay from "containers/general/loadingOverlay"
import { compose } from "redux"
import { getPayload, loadingStatus } from "actions"
import _ from "lodash"
import settings from "settings"
import moment from "moment"
import times from "helpers/times"
import trafficBetween from "helpers/trafficBetween"
import WeeklyMethods from "combined/weekly"
import WeeklyRender from "components/WeeklyRender"
import yearlyTimes from "helpers/yearlyTimes"
import currentUser from "helpers/currentUser"
import helpers from "helpers/helpers"

//! Internal Weekly Report
class WeeklyReport extends Component {
	constructor(props) {
		super(props)
		this.user = currentUser()
		this.state = {
			name: "",
			ready: false,
			times: times(),
			active: settings.weekly && settings.weekly.summary ? "summary" : "week",
			selectedYear: parseInt(moment.unix(times().endWeek).format("YYYY")),
			selectedWeek: moment().subtract(7, "days").isoWeek(),
			options: {
				year: {
					value: parseInt(moment.unix(times().endWeek).format("YYYY")),
					label: parseInt(moment.unix(times().endWeek).format("YYYY")),
				},
				week: { value: moment().subtract(7, "days").isoWeek(), label: moment().subtract(7, "days").isoWeek() },
				active:
					settings.weekly && settings.weekly.summary
						? { value: "summary", label: "Summary" }
						: { value: "week", label: "Week" },
			},
			startWeek: times().lastWeek,
			endWeek: times().lastWeekEnd,
			priorStartWeek: times().priorStartWeek,
			priorEndWeek: times().priorEndWeek,
			startYear: moment().startOf("year").unix(),
			sales: [],
			lastYearSales: [],
			lastYearCancels: [],
			closings: [],
			bustouts: [],
			allSales: [],
			allBusts: [],
			weeklyTotals: {},
			traffic: 0,
			processTraffic: 0, // this is used when you select a previous week, then go to YTD, then go back to weekly.  Before it was losing the processed traffic.
			sorted: {
				sales: [],
				cancels: [],
				closings: [],
				starts: [],
			},
			cumulativeShowLabels: {
				display: true,
				flip: () => {
					let c = _.cloneDeep(this.state.cumulativeShowLabels)
					this.setState({
						cumulativeShowLabels: { display: !c.display, flip: c.flip },
					})
				},
			},
		}
		if (this.state.selectedWeek == 53) {
			// We split week 53 and week 1 into two weeks for eoy reporting.  week 1 is internationally known as the week that contains jan 1, but we split it.
			if (_.has(yearlyTimes, `${this.state.selectedYear}.lastWeek.start`)) {
				this.state.options.year = { value: this.state.selectedYear, label: this.state.selectedYear }
				this.state.startWeek = yearlyTimes[this.state.selectedYear].lastWeek.start
				this.state.endWeek = yearlyTimes[this.state.selectedYear].lastWeek.end
				this.state.startDayName = moment.unix(this.state.startWeek).format("dddd")
				this.state.endDayName = moment.unix(this.state.endWeek).format("dddd")
				this.state.startYear = moment.unix(this.state.startWeek).startOf("year").unix()
			}
		}
		// 2021 ended with only 52 weeks (https://weeknumber.com/2021/52) - so if this is the case, we need to check and see if wee k52 is selected and if there are only 52 weeks.  If true, then the last day is the 31st of december
		if (this.state.selectedWeek == 52 && moment().year(this.state.selectedYear).isoWeeksInYear() == 52) {
			console.log("%c" + `In week 52 - only 52 weeks this selected year.`, "background: #222; color: #bada55")
			//this.state.endWeek = moment().year(this.state.selectedYear).endOf("year").endOf("day").unix()
			//this.state.endDayName = moment.unix(this.state.endWeek).format("dddd")
		}
		try {
			if (this.props.activeProperties[0]) {
				let property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
				this.state.property = property
			}
		} catch (error) {
			console.log(error)
		}

		this.methods = new WeeklyMethods()
	}

	componentDidMount() {
		this.props.getPayload({
			communityPerformance: {
				start: this.state.startWeek,
				end: this.state.endWeek,
				selectedWeek: this.state.selectedWeek,
				selectedYear: this.state.selectedYear,
			},
			weekly: true,
			weeklyMapping: _.get(settings, "weekly.mapping") ? true : false,
		})

		this.buildData()
	}

	async componentDidUpdate(prevProps) {
		if (this.props.payloadStatus !== prevProps.payloadStatus) {
			this.setState({ ready: false })
			this.buildData()
		}
		if (!_.isEqual(prevProps.activeProperties, this.props.activeProperties)) {
			this.setState({ ready: false })
			await this.props.getPayload({
				communityPerformance: {
					start: this.state.startWeek,
					end: this.state.endWeek,
					selectedWeek: this.state.selectedWeek,
					selectedYear: this.state.selectedYear,
				},
				weekly: true,
				weeklyMapping: _.get(settings, "weekly.mapping") ? true : false,
			})
			this.buildData()
		}
	}

	async buildData(processedTraffic, opts) {
		if (this.props.activeProperties.length !== 1) {
			return
		}
		let state = _.cloneDeep(this.state)
		let name
		let sale_date = "sale_date"
		let closing_date = "closing_date"
		let bustout_date = "bustout_date"
		if (settings?.weekly?.useInputDate) {
			sale_date = "addedDate"
			closing_date = "closing_report_time"
			bustout_date = "bustout_report_time"
		}
		const buildWeekly = (monthly) => {
			let weeklyTotals = {
				gross: 0,
				net: 0,
				busts: 0,
				traffic: 0,
				closings: 0,
				starts: 0,
				builderTraffic: 0,
				welcomeTraffic: 0,
				copilot: 0,
				numberVisits: {
					1: 0,
					2: 0,
					3: 0,
					4: 0,
					"5+": 0,
				},
			}
			let allSales = []
			let salesInput = []
			let closings = []
			let projections = []
			let bustouts = []
			let lastYearSales = []
			let lastYearCancels = []
			let traffic
			let trafficArray = {
				individual: [],
				grouped: [],
			}
			let starts
			let specs = []
			let webAnalytics = _.get(this.props.payload, `exec.weeklyReport.webAnalytics`)
			let store
			if (state.selectedWeek == 52 && moment().year(state.selectedYear).isoWeeksInYear() == 52) {
				//state.endWeek = moment().year(state.selectedYear).endOf("year").endOf("day").unix()
				//state.endDayName = moment.unix(state.endWeek).format("dddd")
			}
			if (monthly) {
				// Start goes back to the first of the month, end should stay at the usual end of the selected week, so dont change.
				state.startWeek = moment.unix(state.startWeek).startOf("month").unix()
				state.startDayName = moment.unix(state.startWeek).format("dddd")
				state.priorStartWeek = moment.unix(state.startWeek).subtract(1, "year").unix()
			}
			// Viewing Week Mode
			starts = _.filter(this.props.payload.exec.lots, (v) => {
				return v.start_date >= state.startWeek && v.start_date < state.endWeek
			})
			weeklyTotals.starts = starts.length
			let prop = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
			if (prop) {
				name = prop.name
			}
			// Weekly totals
			_.forEach(this.props.payload.exec.sales, (v) => {
				if (v[sale_date] >= state.startWeek && v[sale_date] < state.endWeek) {
					allSales.push(v)
					weeklyTotals.gross++
				}
				if (v.addedDate >= state.startWeek && v.addedDate < state.endWeek) {
					salesInput.push(v)
				}
				if (v[bustout_date] && v[bustout_date] >= state.startWeek && v[bustout_date] < state.endWeek) {
					bustouts.push(v)
					weeklyTotals.busts++
				}
				if (v[closing_date] && v[closing_date] >= state.startWeek && v[closing_date] < state.endWeek) {
					closings.push(v)
					weeklyTotals.closings++
				}
				// Last Year
				if (v[sale_date] >= state.priorStartWeek && v[sale_date] < state.priorEndWeek) {
					lastYearSales.push(v)
				}
				if (v[bustout_date] >= state.priorStartWeek && v[bustout_date] < state.priorEndWeek) {
					lastYearCancels.push(v)
				}
			})

			_.forEach(this.props.payload.exec.projections, (v) => {
				if (
					v.month == state.times.curMonth &&
					v.property == this.props.activeProperties[0] &&
					v.year == state.times.year
				) {
					projections.push(v)
				}
			})
			weeklyTotals.net = weeklyTotals.gross - weeklyTotals.busts
			if (processedTraffic) {
				// island
				traffic = processedTraffic
			} else {
				try {
					trafficArray.grouped = this.props.payload.exec.traffic.grouped
					trafficArray.individual = this.props.payload.exec.traffic.individual
					traffic =
						this.props.payload.exec.weeklyReport.trafficCount.individual +
						this.props.payload.exec.weeklyReport.trafficCount.grouped
					// Current year, but in the future, so this is 0
					if (state.selectedYear == moment().year() && state.selectedWeek > state.times.curWeek) {
						traffic = 0
					}
				} catch (e) {
					console.log(e)
				}
			}
			weeklyTotals.traffic = traffic
			// some devs want to split builder vs welcome
			let trafficEmailStore = {}
			try {
				_.forEach(this.props.payload.exec.weeklyReport.trafficEntries.ytd.individual, (v) => {
					if (v.traffic_date >= state.startWeek && v.traffic_date < state.endWeek) {
						if (v.welcomeCenter) weeklyTotals.welcomeTraffic++
						else weeklyTotals.builderTraffic++
						if (!_.has(trafficEmailStore, v.email)) {
							trafficEmailStore[v.email] = 0
						}
						if (v.copilot) weeklyTotals.copilot++
						trafficEmailStore[v.email]++
					}
				})
				_.forEach(this.props.payload.exec.weeklyReport.trafficEntries.ytd.grouped, (v) => {
					if (v.traffic_date >= state.startWeek && v.traffic_date < state.endWeek) {
						if (v.welcomeCenter) weeklyTotals.welcomeTraffic += v.prospect_count + v.realtor_count
						else weeklyTotals.builderTraffic += v.prospect_count + v.realtor_count
					}
				})

				// Now add the number of visits
				_.forEach(trafficEmailStore, (v) => {
					if (v >= 5) {
						weeklyTotals.numberVisits["5+"]++
					} else {
						weeklyTotals.numberVisits[v]++
					}
				})
			} catch (e) {
				console.log(e)
			}

			// Spec inventory
			store = {}
			_.forEach(this.props.payload.exec.lots, (v) => {
				if (v[closing_date] || !v.start_date || v.model || !v.takedown_date) return
				if (!v.lot_type_name) {
					//console.log(`Cant find lot type name for ${v.address}`)
					return
				}
				if (!v.builder_name) {
					//console.log(`Cant find builder name for ${v.address}`)
					return
				}
				if (!v.section_name) {
					//console.log(`Cannot find section name for LotID: ${v.address}`)
					return
				}
				v.builder_name = v.builder_name.replace(/[^\w- ]+/g, "")
				v.section_name = v.section_name.replace(/[^\w- ]+/g, "")
				let path = `${v.builder_name}.${v.lot_type_name}.${v.section_name}`
				if (!_.has(store, path)) {
					_.setWith(
						store,
						path,
						{
							under_construction_contract: 0,
							under_construction_no_contract: 0,
							move_in_ready_specs: 0,
						},
						Object
					)
				}
				if (!v.sale_id && !v.complete_date) {
					store[v.builder_name][v.lot_type_name][v.section_name].under_construction_no_contract++
				} else if (v.sale_id && !v.complete_date) {
					store[v.builder_name][v.lot_type_name][v.section_name].under_construction_contract++
				}
				if (v.complete_date && !v.sale_id) {
					store[v.builder_name][v.lot_type_name][v.section_name].move_in_ready_specs++
				}
			})
			_.forEach(store, (v1, builder) => {
				_.forEach(v1, (v2, lot_type) => {
					_.forEach(v2, (v, section) => {
						specs.push({
							builder,
							lot_type,
							section,
							under_construction_contract: v.under_construction_contract,
							under_construction_no_contract: v.under_construction_no_contract,
							move_in_ready_specs: v.move_in_ready_specs,
						})
					})
				})
			})
			return {
				weeklyTotals,
				allSales,
				salesInput,
				sales: allSales,
				closings,
				projections,
				bustouts,
				lastYearSales,
				lastYearCancels,
				traffic,
				starts,
				specs,
				weekly_message: prop ? prop.weekly_message : "",
				webAnalytics,
				trafficArray,
			}
		}
		const buildYearly = async () => {
			let weeklyTotals = {
				gross: 0,
				net: 0,
				busts: 0,
				traffic: 0,
				closings: 0,
				starts: 0,
				copilot: 0,
				builderTraffic: 0,
				welcomeTraffic: 0,
				numberVisits: {
					1: 0,
					2: 0,
					3: 0,
					4: 0,
					"5+": 0,
				},
			}
			let allSales = []
			let closings = []
			let salesInput = []
			let projections = []
			let bustouts = []
			let lastYearSales = []
			let lastYearCancels = []
			let traffic
			let starts
			let priorLastYear = moment.unix(state.startYear).subtract(1, "year").startOf("year").unix()
			if (moment().year() !== state.selectedYear) {
				//! Viewing previous year
				//reset variables for previous year
				state.startYear = moment().year(state.selectedYear).startOf("year").unix()
				state.endWeek = moment(`${state.selectedYear}${state.selectedWeek}`, "YYYYW").endOf("isoweek").unix()
				state.endYear = moment().year(state.selectedYear).endOf("year").unix()
				/* state.priorEndWeek = moment(`${state.selectedYear - 1}${state.selectedWeek}`, "YYYYW")
					.endOf("isoweek")
					.unix() */
				state.priorEndWeek = moment.unix(state.endWeek).subtract(1, "year").unix()
				state.priorEndYear = moment()
					.year(state.selectedYear - 1)
					.endOf("year")
					.unix()
				priorLastYear = moment()
					.year(state.selectedYear - 1)
					.startOf("year")
					.unix()
				starts = _.filter(this.props.payload.exec.lots, (v) => {
					return v.start_date >= state.startYear && v.start_date <= state.endWeek
				})
				weeklyTotals.starts = starts.length
				let prop = _.find(this.props.payload.public.properties, {
					id: this.props.activeProperties[0],
				})
				if (prop) {
					name = prop.name
				}
				_.forEach(this.props.payload.exec.projections, (v) => {
					if (v.property == this.props.activeProperties[0] && v.year == state.selectedYear) {
						projections.push(v)
					}
				})
				// yearly totals
				_.forEach(this.props.payload.exec.sales, (v) => {
					if (v[sale_date] >= state.startYear && v[sale_date] < state.endWeek) {
						allSales.push(v)
						weeklyTotals.gross++
					}
					if (v.addedDate >= state.startYear && v.addedDate < state.endWeek) {
						salesInput.push(v)
					}
					if (v[bustout_date] >= state.startYear && v[bustout_date] < state.endWeek) {
						bustouts.push(v)
						weeklyTotals.busts++
					}
					if (v[closing_date] >= state.startYear && v[closing_date] < state.endWeek) {
						closings.push(v)
						weeklyTotals.closings++
					}
					// Last Year
					if (v[sale_date] >= priorLastYear && v[sale_date] < state.priorEndWeek) {
						lastYearSales.push(v)
					}
					if (v[bustout_date] >= priorLastYear && v[bustout_date] < state.priorEndWeek) {
						lastYearCancels.push(v)
					}
				})
				weeklyTotals.net = weeklyTotals.gross - weeklyTotals.busts
				let traffic = await trafficBetween(this.props.activeProperties, state.startYear, state.endWeek)
				weeklyTotals.traffic = traffic.data.individual.length + traffic.data.groupedTotal
				let trafficEmailStore = {}
				_.forEach(traffic.data.individual, (v) => {
					if (v.welcomeCenter) weeklyTotals.welcomeTraffic++
					else weeklyTotals.builderTraffic++
					if (!_.has(trafficEmailStore, v.email)) {
						trafficEmailStore[v.email] = 0
					}
					if (v.copilot) weeklyTotals.copilot++
					trafficEmailStore[v.email]++
				})
				_.forEach(traffic.data.grouped, (v) => {
					if (v.welcomeCenter) weeklyTotals.welcomeTraffic += v.prospect_count + v.realtor_count
					else weeklyTotals.builderTraffic += v.prospect_count + v.realtor_count
				})
				// Now add the number of visits
				_.forEach(trafficEmailStore, (v) => {
					if (v >= 5) {
						weeklyTotals.numberVisits["5+"]++
					} else {
						weeklyTotals.numberVisits[v]++
					}
				})
			} else {
				//! viewing this year for ytd
				// Viewing Year to date
				starts = _.filter(this.props.payload.exec.lots, (v) => {
					return v.start_date >= state.startYear && v.start_date <= state.endWeek
				})
				weeklyTotals.starts = starts.length
				let prop = _.find(this.props.payload.public.properties, {
					id: this.props.activeProperties[0],
				})
				if (prop) {
					name = prop.name
				}
				_.forEach(this.props.payload.exec.projections, (v) => {
					if (v.property == this.props.activeProperties[0] && v.year == state.times.year) {
						projections.push(v)
					}
				})
				// Weekly totals
				_.forEach(this.props.payload.exec.sales, (v) => {
					if (v[sale_date] >= state.startYear && v[sale_date] < state.endWeek) {
						allSales.push(v)
						weeklyTotals.gross++
					}
					if (v.addedDate >= state.startYear && v.addedDate < state.endWeek) {
						salesInput.push(v)
					}
					if (v[bustout_date] >= state.startYear && v[bustout_date] < state.endWeek) {
						bustouts.push(v)
						weeklyTotals.busts++
					}
					if (v[closing_date] >= state.startYear && v[closing_date] < state.endWeek) {
						closings.push(v)
						weeklyTotals.closings++
					}
					// Last Year
					if (v[sale_date] >= priorLastYear && v[sale_date] < state.priorEndWeek) {
						lastYearSales.push(v)
					}
					if (v[bustout_date] >= priorLastYear && v[bustout_date] < state.priorEndWeek) {
						lastYearCancels.push(v)
					}
				})
				weeklyTotals.net = weeklyTotals.gross - weeklyTotals.busts
				try {
					traffic =
						this.props.payload.exec.weeklyReport.trafficCount.ytd.individual +
						this.props.payload.exec.weeklyReport.trafficCount.ytd.grouped
					weeklyTotals.traffic = traffic
					let trafficEmailStore = {}
					_.forEach(this.props.payload.exec.weeklyReport?.trafficEntries.ytd.individual, (v) => {
						if (v.traffic_date >= state.startYear && v.traffic_date < state.endWeek) {
							if (v.welcomeCenter) weeklyTotals.welcomeTraffic++
							else weeklyTotals.builderTraffic++
							if (!_.has(trafficEmailStore, v.email)) {
								trafficEmailStore[v.email] = 0
							}
							if (v.copilot) weeklyTotals.copilot++
							trafficEmailStore[v.email]++
						}
					})
					_.forEach(this.props.payload.exec.weeklyReport?.trafficEntries.ytd.grouped, (v) => {
						if (v.traffic_date >= state.startYear && v.traffic_date < state.endWeek) {
							if (v.welcomeCenter) weeklyTotals.welcomeTraffic += v.prospect_count + v.realtor_count
							else weeklyTotals.builderTraffic += v.prospect_count + v.realtor_count
						}
					})
					// Now add the number of visits
					_.forEach(trafficEmailStore, (v) => {
						if (v >= 5) {
							weeklyTotals.numberVisits["5+"]++
						} else {
							weeklyTotals.numberVisits[v]++
						}
					})
				} catch (e) {
					console.log(e)
				}
			}

			return {
				weeklyTotals,
				allSales,
				sales: allSales,
				salesInput,
				closings,
				projections,
				bustouts,
				lastYearSales,
				lastYearCancels,
				traffic,
				starts,
			}
		}
		const buildLife = () => {
			let weeklyTotals = {
				gross: 0,
				net: 0,
				busts: 0,
				traffic: 0,
				copilot: 0,
				closings: 0,
				starts: 0,
			}
			let allSales = []
			let closings = []
			let projections = []
			let bustouts = []
			let lastYearSales = []
			let lastYearCancels = []
			let traffic
			let starts
			// Viewing Year to date
			starts = _.filter(this.props.payload.exec.lots, (v) => {
				return v.start_date
			})
			weeklyTotals.starts = starts.length
			let prop = _.find(this.props.payload.public.properties, {
				id: this.props.activeProperties[0],
			})
			if (prop) {
				name = prop.name
			}
			// Weekly totals
			_.forEach(this.props.payload.exec.sales, (v) => {
				if (v[sale_date]) {
					allSales.push(v)
					weeklyTotals.gross++
				}
				if (v[bustout_date]) {
					bustouts.push(v)
					weeklyTotals.busts++
				}
				if (v[closing_date]) {
					closings.push(v)
					weeklyTotals.closings++
				}
				// Last Year
				if (v[sale_date] && v[sale_date]) {
					lastYearSales.push(v)
				}
				if (v[bustout_date] && v[bustout_date]) {
					lastYearCancels.push(v)
				}
			})
			_.forEach(this.props.payload.exec.projections, (v) => {
				if (v.property == this.props.activeProperties[0]) {
					projections.push(v)
				}
			})
			weeklyTotals.net = weeklyTotals.gross - weeklyTotals.busts
			try {
				traffic =
					this.props.payload.exec.weeklyReport.trafficCount.ltd.individual +
					this.props.payload.exec.weeklyReport.trafficCount.ltd.grouped
				weeklyTotals.traffic = traffic
				weeklyTotals.builderTraffic = this.props.payload.exec.weeklyReport.trafficCount.ltd.builderTraffic
				weeklyTotals.welcomeTraffic = this.props.payload.exec.weeklyReport.trafficCount.ltd.welcomeTraffic
				weeklyTotals.numberVisits = this.props.payload.exec.weeklyReport.trafficCount.ltd.numberVisits
			} catch (e) {
				console.log(e)
			}
			return {
				weeklyTotals,
				allSales,
				sales: allSales,
				salesIinput: allSales,
				closings,
				projections,
				bustouts,
				lastYearSales,
				lastYearCancels,
				traffic,
				starts,
			}
		}
		let d
		if (state.active == "week") {
			d = buildWeekly()
			d.dataBucket = "week"
		} else if (state.active == "ytd") {
			d = await buildYearly()
			d.dataBucket = "ytd"
		} else if (state.active == "life") {
			d = buildLife()
			d.dataBucket = "life"
		} else if (state.active == "summary") {
			d = buildWeekly()
			d.dataBucket = "week"
		}
		let weekData = buildWeekly()
		let ytdData = await buildYearly()
		let lifeData = buildLife()
		let monthly = buildWeekly(true)
		let property
		let communityPerformance
		try {
			if (this.props.activeProperties[0]) {
				property = _.find(this.props.payload.public.properties, { id: this.props.activeProperties[0] })
				communityPerformance = this.props.payload.exec.weeklyReport.communityPerformance[this.props.activeProperties[0]]
			}
		} catch (error) {
			console.log(error)
		}
		try {
			this.setState(
				{
					name,
					property,
					...d,
					monthly,
					ytd: ytdData,
					ptd: lifeData,
					communityPerformance,
					...(settings.weekly && settings.weekly.summary
						? {
								summary: {
									weekly: weekData,
									ytd: ytdData,
									life: lifeData,
								},
						  }
						: {}),
					ready: true,
				},
				() => {
					//console.log(this.state)
				}
			)
		} catch (e) {
			console.log(e)
		}
	}

	realtorPercent = () => {
		if (this.state.sales.length == 0) {
			return
		}
		let count = 0
		let total = 0
		let percent = 0
		for (let v of this.state.sales) {
			if (settings.noRealtorTracking.includes(v.property)) {
				continue
			}
			if (v.transfer_date || v.cancel_date || (v[bustout_date] && !settings.realtorGross)) {
				continue
			}
			if (v.realtor_involved === 1) {
				count++
			}
			total++
		}

		percent = count / total
		if (!isFinite(percent)) {
			percent = 0
		}
		percent = percent.toFixed(2)
		percent = Math.round(parseFloat(percent) * 100)
		return (
			<div className="gauge">
				<Chart
					options={helpers.gaugeOptions("Cancel Rate")}
					series={[percent]}
					type="radialBar"
					width={"100%"}
				/>
			</div>
		)
	}

	changeReportType = (v) => {
		let state = _.cloneDeep(this.state)
		state.active = v.value
		state.options.active = v

		this.setState(state, () => {
			this.buildData()
		})
	}

	changeReport = async (v, type) => {
		this.props.loadingStatus(true)
		let state = _.cloneDeep(this.state)

		if (type == "week") {
			state.selectedWeek = v.value
		} else {
			state.selectedYear = v.value
		}
		state.options.year = { value: state.selectedYear, label: state.selectedYear }
		state.options.week = { value: state.selectedWeek, label: state.selectedWeek }
		//let start = moment().week(state.selectedWeek).year(state.selectedYear).startOf("isoweek").unix()
		//let start = moment().year(state.selectedYear).isoWeek(state.selectedWeek).startOf("isoweek").unix()
		let start = moment(`${state.selectedYear}${state.selectedWeek}`, "YYYYW").unix()
		//let end = moment.unix(start).endOf("week").add(1, "day").unix()
		let end = moment.unix(start).endOf("isoweek").unix()

		// Wipe manual day names - if they flip around and see week 1, then back to week 2 the week 1 day names will still be set.
		//delete state.startDayName
		//delete state.endDayName
		state.startDayName = false
		state.endDayName = false

		// EOY
		if (state.selectedWeek == 53) {
			console.log("%c" + `In week 53`, "background: #222; color: #bada55")
			start = yearlyTimes[state.selectedYear].lastWeek.start
			end = yearlyTimes[state.selectedYear].lastWeek.end
			state.startDayName = moment.unix(start).format("dddd")
			state.endDayName = moment.unix(end).format("dddd")
		} else if (state.selectedWeek === 0 && _.has(yearlyTimes, `${state.selectedYear}.firstWeek.start`)) {
			console.log("%c" + `In week 0`, "background: #222; color: #bada55")
			start = yearlyTimes[state.selectedYear].firstWeek.start
			end = yearlyTimes[state.selectedYear].firstWeek.end
			state.startDayName = moment.unix(start).format("dddd")
			state.endDayName = moment.unix(end).format("dddd")
		}

		// 2021 ended with only 52 weeks (https://weeknumber.com/2021/52) - so if this is the case, we need to check and see if week 52 is selected and if there are only 52 weeks.  If true, then the last day is the 31st of december
		if (state.selectedWeek == 52 && moment().year(state.selectedYear).isoWeeksInYear() == 52) {
			console.log("%c" + `In week 52 - only 52 weeks this selected year.`, "background: #222; color: #bada55")
			//end = moment().year(state.selectedYear).endOf("year").endOf("day").unix()
			//state.endWeek = end
			//state.endDayName = moment.unix(end).format("dddd")
		}

		let traffic = await trafficBetween(this.props.activeProperties, start, end)
		state.traffic = traffic.data.individual.length + traffic.data.groupedTotal
		state.startWeek = start
		state.endWeek = end
		state.startYear = moment.unix(start).startOf("year").unix()
		state.priorStartWeek = moment.unix(start).subtract(1, "year").unix()
		state.priorEndWeek = moment.unix(end).subtract(1, "year").unix()
		state.processedTraffic = state.traffic
		//state.priorStartWeek = moment().year(state.selectedYear - 1).week(state.selectedWeek).startOf("isoweek").unix()
		//state.priorEndWeek = moment.unix(state.priorStartWeek).endOf("week").add(1, "day").unix()
		await this.props.getPayload({
			communityPerformance: {
				selectedWeek: state.selectedWeek,
				selectedYear: state.selectedYear,
				start: state.startWeek,
				end: state.endWeek,
				priorStartWeek: state.priorStartWeek,
				priorEndWeek: state.priorEndWeek,
			},
			weekly: true,
			weeklyMapping: true,
		})
		this.setState(
			state,
			() => {
				this.buildData(state.traffic)
				this.props.loadingStatus(false)
			},
			() => {
				//console.log(this.state)
			}
		)
	}

	render() {
		if (this.state.invalid) {
			return <Redirect to={"/login"} />
		} else if (!this.props.payloadStatus) {
			return (
				<div>
					<Overlay />
					<LoadingOverlay />
				</div>
			)
		} else if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to view reporting.</h1>
				</div>
			)
		} else if (!this.state.ready) {
			return ""
		} else {
			return (
				<div className="weekly">
					<WeeklyRender {...this} type={"internal"} />
				</div>
			)
		}
	}
}

function mapStateToProps(state) {
	return {
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		loadingStatus: state.loadingStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			loadingStatus,
			getPayload,
		},
		dispatch
	)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(WeeklyReport)
